module.exports = __webpack_public_path__ + "img/4-offline.6edee6f6.png";